"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, {
  UiFormAnnotations,
  UiFormController
} from "@/components/form/UiForm.vue";
import { APIDataSource } from "@/components/grid/data-source";
import UiSubmit from "@/components/form/UiSubmit.vue";
import UiGrid, {
  GridController
} from "@/components/grid/UiGrid.vue";
const emptyImage = require("@/assets/img/safety-empty/security-list-null.png");
import i18n from "@/lang";
import { Debounce } from "vue-debounce-decorator";
class AddWebPageForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.web_page_name = "";
    this.web_page_url = "";
    this.web_page_platform_group = "";
    this.web_page_platform_group_second = "";
    this.web_page_description = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.web_page_name_rule"),
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_name", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.web_page_url_rule"),
      trigger: "blur"
    },
    {
      validator: (rule, value, callback) => {
        let runoob = /^(http:\/\/|https:\/\/)([a-zA-Z0-9\-.]+)(:[0-9]+)?(\/[^\s]*)?$/;
        if (value === null || value === "") {
          callback();
          return true;
        }
        let search = value.search(runoob);
        if (search < 0) {
          callback(
            i18n.t("add_web_pages.add_web_page_url_incorrect")
          );
          return false;
        }
        callback();
        return true;
      },
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_url", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.platform_group_rule"),
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_platform_group", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.platform_group_rule"),
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_platform_group_second", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_web_pages.web_page_description_rule"),
      trigger: "blur"
    }
  ])
], AddWebPageForm.prototype, "web_page_description", 2);
const _gridController = new GridController(
  new APIDataSource("api://base.auth/api/v1/web-resource-elements")
);
let EditWebResourceDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.formController = new AddWebPageForm();
    this.submitLoading = false;
    this.webPagePlatformListAll = [];
    this.webPagePlatformGroup = [];
    this.webPagePlatformGroupSecond = [];
    this.webPageId = "";
    this.webElementNum = 0;
    this.empty_image = emptyImage;
    this.gridController = _gridController;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.pagePosition = "dialog";
    });
  }
  open(data) {
    return __async(this, null, function* () {
      try {
        this.webPageId = data.id;
        this.webElementNum = data.xpathNum;
        yield this.getPlatformGroupList();
        yield this.getResourceById();
        if (this.webElementNum > 0) {
          this.gridController.query.filter = `webpageResourceId == ${data.id}`;
          yield this.gridController.search();
        }
        this.dialog.visible = true;
      } catch (error) {
      }
    });
  }
  getResourceById() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/web-resource`, {
          params: {
            search: `id==${this.webPageId}`
          }
        });
        console.log(response.data);
        this.formController.web_page_name = response.data.name;
        this.formController.web_page_description = response.data.description;
        this.formController.web_page_url = response.data.url;
        this.formController.web_page_platform_group = response.data.groupIds[0];
        this.changeSecondGroupsList(response.data.groupIds[0]);
        this.formController.web_page_platform_group_second = response.data.groupIds[1];
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getPlatformGroupList() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.auth/api/v1/web-resource-groups`
        );
        this.webPagePlatformListAll = response.data.datas;
        this.handleGroupCollapsed(response.data.datas);
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //处理分离一二级分组
  handleGroupCollapsed(groups) {
    let arr = [];
    groups.forEach((item) => {
      if (item.parentId === "root") {
        arr.push(item);
      }
    });
    this.webPagePlatformGroup = arr;
  }
  //获取第二级分组列表
  changeSecondGroupsList(id) {
    let arr = [];
    this.webPagePlatformListAll.forEach((item) => {
      if (item.parentId === id) {
        arr.push(item);
      }
    });
    this.webPagePlatformGroupSecond = arr;
  }
  goBack() {
    this.formController.web_page_name = "";
    this.formController.web_page_url = "";
    this.formController.web_page_platform_group = "";
    this.formController.web_page_platform_group_second = "";
    this.formController.web_page_description = "";
    this.dialog.visible = false;
  }
  refreshElements() {
    return __async(this, null, function* () {
      try {
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  deleteElement(item) {
    return __async(this, null, function* () {
      try {
        yield API.delete(`api://base.auth/api/v1/web-resource-elements/${item.id}`);
        this.webElementNum = this.webElementNum - 1;
        yield this.refreshElements();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  submitForm() {
    return __async(this, null, function* () {
      try {
        let submitResourceData = {
          "name": this.formController.web_page_name,
          "groupId": this.formController.web_page_platform_group_second,
          "url": this.formController.web_page_url,
          "description": this.formController.web_page_description,
          "matchRuleType": "CURRENT_PAGE",
          "shieldType": "PAGE"
        };
        if (this.webElementNum > 0) {
          submitResourceData.shieldType = "ELEMENT";
        }
        let response = yield API.put(`api://base.auth/api/v1/web-resources/${this.webPageId}`, submitResourceData);
        this.$message.success(
          this.$t("edit_web_resource.edit_web_resource_by_hand_success")
        );
        this.$emit("editSuccess", this.webPageId);
        this.goBack();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Debounce(400)
], EditWebResourceDialog.prototype, "refreshElements", 1);
EditWebResourceDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog,
      UiGrid
    }
  })
], EditWebResourceDialog);
export {
  EditWebResourceDialog as default
};
